<template>
  <panel title="Clients">
    <v-card
      flat>    
      <v-toolbar 
        height="20" 
        color="white" 
        flat 
        pt-1 
        mb-4
        pb-3>
        <v-layout
          >
          <v-flex 
            xs2
            md2
            ml-2
            pl-2>
            <v-toolbar-title
              :class="classText">
              Client's Name
            </v-toolbar-title>
          </v-flex>
          <v-flex 
            xs2
            ml-2
            >
            <v-toolbar-title
               :class="classText">
              Date Of Report
            </v-toolbar-title>
          </v-flex>
          <v-flex
            xs2
            pl-2
            ml-2>
            <v-toolbar-title
               :class="classText">
              Download Report
            </v-toolbar-title>
          </v-flex>
        <v-flex 
          sm6
          pl-5
          hidden-xs-only
          >
          <v-toolbar-title
            :class="classText">
            Group Membership
          </v-toolbar-title>
        </v-flex>
      </v-layout>
    </v-toolbar>
    <v-divider/>
    <div
      v-if="(tempClients !== null && tempClients !== undefined)">
      <v-list>
          <v-list-tile
            v-for="client in tempClients"
            :key="client.id"
            >
            <!-- <v-layout
              class="text-xs-left"> -->
            <v-flex
              xs3
              md2
              justify-start
              align-start
              class="text-xs-left"
              >
              <v-btn 
                :to="{
                  name: 'client',
                  params: {
                    clientId: client.id
                  }
                }"
                flat
                >
                <v-list-tile-action>
                  <div class="body-2 text-xs-left" > {{ client.name | fixName }} </div>
                </v-list-tile-action> 
            </v-btn>
          </v-flex>
          <v-flex 
            xs2
            ml-4
            pl-2
            justify-start
            align-start
            >
            <v-list-tile-content>
             <v-list-tile-title 
                class="body-2 text-xs-left">
                {{ cleanTime(client.ClientResult.completedDateTime) }}
             </v-list-tile-title> 
            </v-list-tile-content>
          </v-flex> 
          <v-flex 
              xs2
              md2
              ml-2
              pr-1
              mr-1   
              >
              <v-btn  
                icon
                @click="downloadPDF(client.name, client.id)">
                <v-icon>
                  fas fa-file-download
                </v-icon>  
              </v-btn> 
          </v-flex>
          <v-flex
            sm6
            ml-3
            pl-4
            hidden-xs-only
            >
            <div v-if="client.groupList !== undefined && client.groupList !== null">
              <v-layout
                
                row>
                <div 
                  v-for="(group, index) in client.groupList"
                  :key="group.groupId">
                   <div v-if="index <= 1">
                   <v-btn 
                      :to="{
                        name: 'group',
                        params: {
                          groupId: group.groupId
                        }
                      }"
                      flat> 
                      <v-list-tile-action> 
                        <div class="body-2" > {{ group.groupName }} </div>
                      </v-list-tile-action>    
                 </v-btn>
                  </div>
                   <div v-else-if="index === 2">
                        <v-btn
                        flat>
                          <v-list-tile-action> 
                        <div class="body-2" > ... </div>
                      </v-list-tile-action>  
                      </v-btn>  
                      </div>
          
              </div>
            </v-layout>
          </div>
        </v-flex>
      <!-- </v-layout> -->
    </v-list-tile> 
  </v-list>
</div>
      <div v-else>
        <v-progress-circular
          indeterminate
          color="primary"
        />
      </div>
    </v-card>
  </panel>
</template>
<script>
import ClientsService from '@/services/ClientsService'
import ClientsGroupService from '@/services/ClientsGroupService'
import { mapState } from 'vuex'
import { fixName } from '@/components/globals/consts'
import EventBus from '@/main'

export default {
  data() {
    return {
      //clients: null,
      tempClients: null,
      classText: "text-xs-left subheading font-weight-bold"
      //groupResults: null,
      //loading: true
    }
  },
	computed: {
		...mapState([
			'isUserLoggedIn',
		//	'user',
      'route',
      'testType'
		])
  },
  watch: {
    "$route.query.search": {
      immediate: true,
      async handler(value) {
        try {
          //let tempClients = null
          //console.log(value)
          //this.groupList = null

          this.tempClients = null
          let tempClients = (await ClientsService.index(value,this.testType)).data
          if (tempClients) {
            await this.addGroupInfo(tempClients)
            this.tempClients = tempClients.sort(this.orderByDate)
          } 
        } catch (e) {
          console.log(e)
        }

      }
    }
  },
	async mounted () {
		await EventBus.$on("renderClients", async (value) => {
        //let tempClients = null
        //this.groupList = null
        
        this.tempClients = null
        let tempClients = (await ClientsService.index(value,this.testType)).data
        if (tempClients) {
          await this.addGroupInfo(tempClients)
          this.tempClients = tempClients.sort(this.orderByDate)
          //this.tempClients = tempClients
        }
	  })
  },
    beforeDestroy() {
    try {
      //
    } catch (err) {
      console.log(err);
    }
  },


  methods: {
    cleanTime(time) {
      try {
          let d = new Date(Date.parse(time));
          let dateString = navigator.language
          if (d == undefined) {
            return 'Unknown'
          } else { 
            return d.toLocaleDateString(dateString)
          }
      } catch (e) {
        console.log(e)
      }
    },
    orderByDate(a, b) {
      try {
      if (a.ClientResult.completedDateTime > b.ClientResult.completedDateTime) {
        return -1
      } else if (a.ClientResult.completedDateTime < b.ClientResult.completedDateTime) {
        return 1
      }
      return 0
      } catch (e) {
        console.log(e)
      }
    },
    async saveByteArray (reportName, byte) {
      try {
        let blob = new Blob([byte], {type: "application/pdf"});
        //console.log(blob)
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        let fileName = reportName;
        link.download = fileName;
        document.body.appendChild(link)
        link.click();
        blob = null
        link = null
      } catch (e) {
        console.log(e)
      }
    },
    base64ToArrayBuffer (base64) {
      try {
        let binaryString = window.atob(base64)
        let binaryLen = binaryString.length
        let bytes = new Uint8Array(binaryLen)
        for (let i = 0; i < binaryLen; i++) {
          let ascii = binaryString.charCodeAt(i);
          bytes[i] = ascii;
        }
        binaryString = null
        return bytes
      } catch (e) {
        console.log(e)
      }
     }, 
    async downloadPDF (name, id) {
      try {
        let buf = (await ClientsService.showPDF(id)).data.ClientResult.report.data
        let uintArr = new Uint8Array(buf)
        let uintStr = this.makeString(uintArr)
        let base64String = window.btoa(uintStr)
        
        //ORIGINAL. Spread operator was throwing errors with Safari
        //let base64String = window.btoa(String.fromCharCode(...new Uint8Array(buf)))
        this.arrayBuffer = this.base64ToArrayBuffer(base64String);
        this.saveByteArray(`${name}.pdf`, this.arrayBuffer);
        
        this.arrayBuffer = null
        buf = null
        base64String = null
      } catch (e) {
        console.log(e)
      }
    },
    makeString (arr) {
      let retStr = ''
      for (let x of arr) {
        let tStr = String.fromCharCode(x)
        retStr += tStr 
      }
      retStr = retStr.trim()
      return retStr
    },

    async addGroupInfo(tempClients) {
      try {
        if (tempClients) {
          for (let client in tempClients) {
            let clientData = tempClients[client]
          
              let groupResults = (await ClientsGroupService.showClientInGroups(clientData.id)).data;
              let groupList = []
              if (groupResults == null || groupResults.length === 0) {
                //console.log('')
              } else if (groupResults.length > 0) {
                for (let i in groupResults) {
                  let x = {}
                  x.groupName = groupResults[i].Group.name
                  x.groupId = groupResults[i].GroupId
                  groupList.push(x)
                }
                tempClients[client].groupList = groupList
              }
            }
          }
          this.tempClients = tempClients
        } catch (e) {
          //console.log('in addgroupinfo')
          console.log(e);
        }  
    } 
  }
}
</script>
.name {
  text-align: left;
}
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Clients/ClientsPanel.vue